import { z } from "zod";

import { handlerCaseSchema } from "../../nodeDesigns/triggerDesignsStateSchema.ts";

export const addHandlerActionSchema = z.object({
  type: z.literal("ADD_HANDLER"),
  payload: z.object({
    triggerId: z.number().int(),
    id: z.number().int(),
    label: z.string().optional(),
    cases: z.array(handlerCaseSchema).optional(),
  }),
});

export type AddHandlerAction = z.infer<typeof addHandlerActionSchema>;

export const removeHandlerActionSchema = z.object({
  type: z.literal("REMOVE_HANDLER"),
  payload: z.object({
    id: z.number().int(),
  }),
});

export type RemoveHandlerAction = z.infer<typeof removeHandlerActionSchema>;

export const updateHandlerActionSchema = z.object({
  type: z.literal("UPDATE_HANDLER"),
  payload: z.object({
    id: z.number().int(),
    label: z.string().optional(),
    cases: z.array(handlerCaseSchema).optional(),
  }),
});

export type UpdateHandlerAction = z.infer<typeof updateHandlerActionSchema>;

export const reorderHandlerActionSchema = z.object({
  type: z.literal("REORDER_HANDLER"),
  payload: z.object({
    id: z.number().int(),
    newIndex: z.number().int().nonnegative(),
  }),
});

export type ReorderHandlerAction = z.infer<typeof reorderHandlerActionSchema>;
